import React from 'react';

const PARTNERS = [
    { name: 'SeedLegals', logo: require('../../../../images/landing-pages/home-page/partner-logos/seedlegals_logo.png') },
    { name: 'AI Forge', logo: require('../../../../images/landing-pages/home-page/partner-logos/aI_forge_logo.png') },
    { name: 'Acentis', logo: require('../../../../images/landing-pages/home-page/partner-logos/acentis_logo.png') },
    { name: 'Dignus Muneris', logo: require('../../../../images/landing-pages/home-page/partner-logos/dignus_muneris_logo.png') },
    { name: 'EHE', logo: require('../../../../images/landing-pages/home-page/partner-logos/ehe_logo.png') },
    { name: 'Fractionality', logo: require('../../../../images/landing-pages/home-page/partner-logos/fractionality_logo.png') },
    { name: 'JPJ', logo: require('../../../../images/landing-pages/home-page/partner-logos/jpj_logo.png') },
    { name: 'SU2SU', logo: require('../../../../images/landing-pages/home-page/partner-logos/su2su_logo.png') },
];

const HomeLogoStrip = () => (
    <section className="lp-logos-sec">
        <p className="lp-logos-eyebrow">Trusted by 50+</p>
        <h2 className="lp-logos-title">Our InvestorMatch Partners</h2>
        <div className="lp-logos-strip">
            <div className="lp-logos-track">
                {[...PARTNERS, ...PARTNERS].map((partner, i) => (
                    <span className="lp-logo-chip" key={i}>
                        <img src={partner.logo} alt={partner.name} />
                    </span>
                ))}
            </div>
        </div>
    </section>
);

export default HomeLogoStrip;
